import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  ColStyled,
  RowStyled,
} from './styles';

const ITEMS = [
  {
    cardId: 'services-mutual-funds-link-card',
    cardHeading: 'Mutual funds',
    linkUrl: '/mutual-funds/',
    ariaLabel: 'Learn more about Mutual Funds',
  },
  {
    cardId: 'services-etfs-link-card',
    cardHeading: (<>Exchange&#45;traded fund (ETF)</>),
    linkUrl: '/etfs/',
    ariaLabel: (<>Learn more about Exchange&#45;traded funds</>),
  },
  {
    cardId: 'services-stocks-link-card',
    cardHeading: 'Stocks',
    linkUrl: '/equities-investments/',
    ariaLabel: 'Learn more about Stocks',
  },
  {
    cardId: 'services-bonds-link-card',
    cardHeading: 'Bonds',
    linkUrl: '/bonds/',
    ariaLabel: 'Learn more about Bonds',
  },
  {
    cardId: 'services-cd-link-card',
    cardHeading: 'Certificate of deposit (CD)',
    linkUrl: '/cds/',
    ariaLabel: 'Learn more about CDs',
  },
  {
    cardId: 'services-annuities-link-card',
    cardHeading: 'Annuities',
    linkUrl: '/annuities/',
    ariaLabel: 'Learn more about Annuities',
  },
  {
    cardId: 'services-cash-sweeps-link-card',
    cardHeading: 'Cash Sweep Program',
    linkUrl: '/cash-sweeps/',
    ariaLabel: 'Learn more about Cash Sweeps',
  },
];

export default () => (
  <SectionContainer
    id='brokerage-accounts-services-product-callout-grouping'
    moduleName='product-callout-grouping-module'>
    <Row align='center'>
      <Col
        small={10}
        large={7}>
        <Typography
          align='center'
          component='h2'
          nextElement='graphic'>
          Explore the types of investments that can go into a <WidowBlock>brokerage account</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <RowStyled align='left'>
      {ITEMS.map((item, index) => (
        <ColStyled
          key={`col-${item.cardId}`}
          medium={6}
          large={4}
          disableBottomPadding={(index + 1) === ITEMS.length} // disable bottom padding on last item
        >
          <ProductCard
            cardId={`product-callout-brokerage-accounts-services-${item.cardId}`}
            cardHeading={item.cardHeading}
            linkUrl={item.linkUrl}
            ariaLabel={item.ariaLabel}
            disableBottomPadding={item.disableBottomPadding}
            backgroundVariant='lightB'
            condensed
            fixHeight // keeps all callouts the same height regardless of text wrapping
          />
        </ColStyled>
      ))}
    </RowStyled>
  </SectionContainer>
);
